import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {removeNotification, upsertNotification} from "../app-slice";
import {useRealtime} from "./useRealtime";
import useWorkspaceMembership from "../../models/workspace-membership/use-workspace-membership";
import {normalizeMembershipEntity} from "../../models/workspace-membership/workspace-membership-identity";
import {removeWorkspaceUserRole, upsertWorkspaceUserRole} from "../workspace-graph-slice";

const typeOf = (event) => String(event?.type || event?.event || "").toLowerCase();
const payloadOf = (event) => event?.payload ?? event?.data ?? null;
const removed = (event) => typeOf(event).includes("deleted") || typeOf(event).includes("removed");

export default function useWorkspaceRealtimeSync(enabled = true) {
    const dispatch = useDispatch();
    const realtime = useRealtime();
    const membership = useSelector((state) => state.app.workspaceMembershipData);
    const membershipApi = useWorkspaceMembership();
    const sequence = useRef(0);
    const latest = useRef({membership, membershipApi});
    latest.current = {membership, membershipApi};

    useEffect(() => {
        if (!enabled) return;
        const pending = (realtime.eventQueue || []).filter((event) => Number(event.__realtimeSequence) > sequence.current);
        pending.forEach((event) => {
            sequence.current = Math.max(sequence.current, Number(event.__realtimeSequence));
            const type = typeOf(event);
            const payload = payloadOf(event);
            if (type.startsWith("workspace.") || type.startsWith("workspace-membership.")) {
                latest.current.membershipApi.getWorkspaceMemberships();
            } else if (type.startsWith("user-role.")) {
                if (payload) dispatch(removed(event) ? removeWorkspaceUserRole(payload) : upsertWorkspaceUserRole(payload));
                latest.current.membershipApi.getWorkspaceMemberships();
            } else if (type.startsWith("user-event-log.") && payload) {
                const item = normalizeMembershipEntity(payload, "userEventLog", latest.current.membership?.workspace?.workspace_memberships || []);
                dispatch(removed(event) ? removeNotification(item) : upsertNotification(item));
            } else {
                // Extension modules can subscribe without modifying this platform hook.
                window.dispatchEvent(new CustomEvent("workspace:content-changed", {detail: event}));
            }
        });
    }, [dispatch, enabled, realtime.eventQueue]);
}
